import { WHATSAPP_SIGNUP_FAILURE_REASONS } from 'src/hooks/integrations/facebook/types';
import type { WhatsAppSignupFailureReason } from 'src/hooks/integrations/facebook/types';
import type { AlertType } from 'src/contexts/alert-context';
import type { TranslationKey } from 'src/modules/shared/types/i18n/translation-keys.type';

/** Translated notification and severity for each signup terminal failure. */
export const signupFailureAlerts: Record<
  WhatsAppSignupFailureReason,
  { translationKey: TranslationKey; type: AlertType }
> = {
  [WHATSAPP_SIGNUP_FAILURE_REASONS.CANCELLED]: {
    translationKey: 'settings.integrations.whatsapp.errors.signupCancelled',
    type: 'warning',
  },
  [WHATSAPP_SIGNUP_FAILURE_REASONS.TIMEOUT]: {
    translationKey: 'settings.integrations.whatsapp.errors.signupTimeout',
    type: 'warning',
  },
  [WHATSAPP_SIGNUP_FAILURE_REASONS.META_ERROR]: {
    translationKey: 'settings.integrations.whatsapp.errors.metaSignup',
    type: 'error',
  },
  [WHATSAPP_SIGNUP_FAILURE_REASONS.INCOMPLETE_SESSION]: {
    translationKey: 'settings.integrations.whatsapp.errors.incompleteSession',
    type: 'error',
  },
  [WHATSAPP_SIGNUP_FAILURE_REASONS.CONFIGURATION_ERROR]: {
    translationKey: 'settings.integrations.whatsapp.errors.configuration',
    type: 'error',
  },
  [WHATSAPP_SIGNUP_FAILURE_REASONS.UNSUPPORTED_COMPLETION]: {
    translationKey:
      'settings.integrations.whatsapp.errors.unsupportedCompletion',
    type: 'error',
  },
};
